import { useCallback, useState } from 'react';

import { Apollo } from 'src/gql/generated';

interface FileForRename {
  document: {
    id: UUID;
    name: string;
  };
}

export function useDocumentRename(file: FileForRename) {
  const [isRenaming, setIsRenaming] = useState(false);
  const [renameValue, setRenameValue] = useState('');
  const [updateDocumentProps] = Apollo.useUpdateDocumentPropsMutation();

  const startRename = useCallback(() => {
    setRenameValue(file.document.name);
    setIsRenaming(true);
  }, [file.document.name]);

  const commitRename = useCallback(async () => {
    const trimmed = renameValue.trim();
    if (trimmed && trimmed !== file.document.name) {
      await updateDocumentProps({
        variables: { input: { documentId: file.document.id, documentProps: { name: trimmed } } },
      });
    }
    setIsRenaming(false);
  }, [renameValue, file.document.id, file.document.name, updateDocumentProps]);

  return { commitRename, isRenaming, renameValue, setIsRenaming, setRenameValue, startRename };
}
